























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class MExpansion extends Vue {
  @Prop({ default: false }) readonly value!: boolean;

  get expanded() {
    return this.value;
  }

  set expanded(val: boolean) {
    this.$emit("input", val);
  }
}
